import { ContainerNode, FunctionalComponent, h, render } from "preact";
import { VoiceShoppingCart } from "./Components/shopping-cart";
import { ShoppingCartStore } from "./shop-cart.store";
import { CookieStorage } from "@shared/cookieStorage";
import register from "preact-custom-element";
import { AddOfferingButton } from "./Components/add-offering-button";
import { ShoppingCartStoreOptions, voiceShopStoreStateType } from "./shop-types";
import { IceAnimationHeightProvider } from "../../Shared/Components/IceAnimation/IceAnimationHeightProvider";
import { isB2BPage } from "@shared/Utils";
import { readMbbCartSettings } from "./Helpers/mbb-cart-settings";

type ShoppingCartAppProps = {
  useVoiceStore: voiceShopStoreStateType;
  shoppingCartRootEl: HTMLElement;
  dataNotAvailable: boolean;
};
const shoppingcartApp: FunctionalComponent<ShoppingCartAppProps> = ({
  useVoiceStore,
  shoppingCartRootEl,
  dataNotAvailable,
}: ShoppingCartAppProps) => {
  return (
    <IceAnimationHeightProvider>
      <VoiceShoppingCart
        useVoiceStore={useVoiceStore}
        shoppingCartRootEl={shoppingCartRootEl}
        dataNotAvailable={dataNotAvailable}
      />
    </IceAnimationHeightProvider>
  );
};

export const LoadShoppingCart = (): void => {
  const shoppingCartRootEl = document.querySelector<HTMLElement>("#ShoppingCartApp");
  if (!shoppingCartRootEl) return;

  if (shoppingCartRootEl.dataset.isMbb === "False" && isB2BPage()) {
    return;
  }

  const domain = `.${window.location.host.split(".").slice(1).join(".")}`;
  const cookieJar = new CookieStorage(window.document, 1000 * 60 * 30, domain);
  const shoppingCartContainer = document.querySelector<HTMLElement>("#shoppingCartBackDrop") as ContainerNode;

  const namespace = shoppingCartRootEl.dataset.isMbb === "True" ? "IceMbbShoppingCart" : "IceShoppingCart";

  const storeParams: ShoppingCartStoreOptions = {
    cookieJar: cookieJar,
    namespace: namespace,
    isBusiness: false,
    isMbb: false,
    maxOrders: 5,
    shippingPriceMbb: 0,
  };

  const dataNotAvailable = shoppingCartRootEl.dataset.notAvailable === "true";

  const mbbSettings = readMbbCartSettings([...document.querySelectorAll(".mbb-overview-settings")]);
  if (mbbSettings) {
    storeParams.isMbb = true;
    storeParams.isBusiness = mbbSettings.isBusiness;
    storeParams.maxOrders = mbbSettings.maxOrders;
    storeParams.shippingPriceMbb = mbbSettings.shippingPrice;
  }

  const useVoiceStore = ShoppingCartStore(storeParams);
  render(h(shoppingcartApp, { useVoiceStore, shoppingCartRootEl, dataNotAvailable }), shoppingCartContainer);
};

register(
  AddOfferingButton(),
  "ice-addoffering-button",
  [
    "buttontext",
    "blockid",
    "classname",
    "buttonclassname",
    "ariabuttonlabel",
    "dataid",
    "productname",
    "productpage",
    "analyticslistname",
    "mbbbundle",
  ],
  {
    shadow: false,
  },
);

LoadShoppingCart();
